import { type ReactNode } from 'react'
import EventShow from './show'

type Props = Parameters<typeof EventShow>[0]

export default function EventLanding(props: Props) {
  return <EventShow {...props} />
}

EventLanding.layout = (page: ReactNode) => page
